import { render, staticRenderFns } from "./warning-icon.vue?vue&type=template&id=a99fc6c4"
import script from "./warning-icon.vue?vue&type=script&lang=js"
export * from "./warning-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports